import { FieldArray, useFormikContext } from 'formik';
import * as React from 'react';
import { Card, Col as BCol, Row as BRow } from 'react-bootstrap';
import {
  ColumnWidths,
  DataRowAction,
  Entity,
  Field,
  FieldId,
  getFieldArray,
  getSectionColumnWidths,
  isAllowDeleteRows,
  isFieldEditable,
  Row,
} from 'gossamer-unified';
import { ErrorBoundary } from '../ancillary/ErrorBoundary';
import { FormField } from './FormField';
import { AllValues, FormRow } from './Utils';
// TODO - doesn't work for main-frontend for some reason
// import { FieldBlock } from '../sections/FieldBlock.module.css';
import styles from './FormTiles.module.css';

export interface FormTilesProps<T extends Row> {
  alias?: string;
  columnWidths?: ColumnWidths;
  entity: Entity<T>;
  fieldGroup?: string;
}

export const FormTiles = <T extends {}>(props: FormTilesProps<T>): React.JSX.Element => {
  const identifier = props.alias || props.entity.id;
  const sectionColumnWidths = getSectionColumnWidths(props.columnWidths);
  const { values } = useFormikContext<AllValues>();
  return (
    <ErrorBoundary>
      <FieldArray name={identifier}>
        {(arrayProps) => (
          <BRow className="mb20px">
            {(values[identifier] as FormRow<T>[]).map((values: FormRow<T>, index: number) => (
              <BCol key={index} {...sectionColumnWidths}>
                <FormTile
                  {...props}
                  remove={() => arrayProps.remove(index)}
                  action={values._action}
                  prefix={`${identifier}[${index}].`}
                />
              </BCol>
            ))}
          </BRow>
        )}
      </FieldArray>
    </ErrorBoundary>
  );
};

export interface FormTileProps<T extends Row> {
  action: DataRowAction;
  entity: Entity<T>;
  prefix: string;
  remove: () => void;
}

export const FormTile: React.FC<FormTileProps<any>> = (props) => {
  return (
    <Card className="tile">
      <Card.Body>
        {isAllowDeleteRows(props.entity) && (
          <div className={styles.TileDelete}>
            <button onClick={() => props.remove()} className="ControlIcon" type="button">
              ✖
            </button>
          </div>
        )}
        {getFieldArray(props.entity)
          .filter(([field, _]: [Field, FieldId]) => field.listColumn)
          .map(([field, fieldId]: [Field, FieldId]) => (
            <div id={fieldId} key={fieldId} /* className={FieldBlock} */>
              <div>{field.label}</div>
              <FormField
                editable={isFieldEditable(field, props.action)}
                fullId={`${props.prefix}${fieldId}`}
                field={field}
              />
            </div>
          ))}
      </Card.Body>
    </Card>
  );
};
